import { lazy } from 'react'

export const dynamic = lazy
